<template>
  <div class="accountManagement">
    <header>
      <el-button
        type="primary"
        style="margin-right: 30px;"
        @click="getURLData"
      >授权</el-button>
      <el-input
        v-model="wechatAccountsQuery.wechat_account_name"
        style="max-width: 200px; margin-right: 18px"
        placeholder="公众号名称"
      />
      <el-select
        v-model="wechatAccountsQuery.delivery_person"
        filterable
        placeholder="投放者"
      >
        <el-option
          v-for="item in selectData.filter ? selectData.filter.user : []"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="wechatAccountsQuery.platform"
        filterable
        placeholder="平台"
      >
        <el-option
          v-for="item in selectData.filter ? selectData.filter.platform : []"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="wechatAccountsQuery.novel_name"
        filterable
        placeholder="小说"
      >
        <el-option
          v-for="item in selectData.filter ? selectData.filter.novel : []"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="wechatAccountsQuery.lead"
        filterable
        placeholder="主角"
      >
        <el-option
          v-for="item in selectData.filter ? selectData.filter.lead : []"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="wechatAccountsQuery.status"
        placeholder="状态"
      >
        <el-option
          key="1"
          label="启用"
          value="1"
        />
        <el-option
          key="0"
          label="禁用"
          value="0"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="handleSearch"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="handleReset"
      >重置</el-button>
    </header>
    <main>
      <el-table
        v-loading="loading"
        :data="selectData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
          min-width="100"
        />
        <el-table-column
          prop="account_name"
          label="公众号"
          min-width="150"
        />
        <el-table-column
          prop="app_id"
          label="Appid"
          min-width="180"
        />
        <el-table-column
          prop="group_name"
          label="投放组"
          min-width="150"
        />
        <el-table-column
          prop="user_name"
          label="投放者"
          min-width="150"
        />
        <el-table-column
          prop="platform_name"
          label="平台"
          min-width="150"
        />
        <el-table-column
          prop="novel_name"
          label="小说"
          min-width="150"
        />
        <el-table-column
          prop="lead"
          label="主角"
          min-width="100"
        />
        <el-table-column
          prop="advertiser_type_text"
          label="类型"
          min-width="100"
        />
        <el-table-column
          prop="advertiser_id"
          label="广告主"
          min-width="250"
          align="center"
        >
          <template scope="scope">
            <p
              v-if="!scope.row.advertiser_id || scope.row.advertiser_id.length < 3"
              style="white-space: break-spaces;"
            >
              {{ convertAdvertisers(scope.row.advertiser_id) }}
            </p>
            <el-popover
              v-else
              placement="top-start"
              title="全部"
              width="300"
              trigger="hover"
              popper-class="aa"
              :content="scope.row.advertiser_id.map(item => `${item.account_id}(${item.account_name})`).join('\n')"
            >
              <p
                slot="reference"
                style="white-space: break-spaces;"
              >{{ convertAdvertisers(scope.row.advertiser_id) }}</p>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          min-width="90"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-show="scope.row.status === 1">正常</el-tag>
            <el-tag
              v-show="scope.row.status === 2"
              type="info"
            >解绑</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="150"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="$refs.updateWindow.open(scope.row)"
            >编辑</el-button>
            <el-button
              size="mini"
              @click="$refs.addAccountDrawer.open(scope.row)"
            >绑定</el-button>

            <el-dropdown
              v-if="scope.row.is_slave !== 1"
              trigger="click"
              style="margin-top:5px; margin-right: 5px"
              @command="getCommand($event, scope.row.id, scope.row.advertiser_id, scope.row.advertiser_type)"
            >
              <el-button
                size="mini"
                type="primary"
              >绑定广告主</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">腾讯广告</el-dropdown-item>
                <el-dropdown-item :command="2">巨量广告</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <pagination-right
      :total="selectData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <UpdateWindow
      ref="updateWindow"
      :select-data="selectData"
      @confirm="getConfirmData"
    />
    <global-window
      title="授权"
      :visible.sync="dialogVisible"
      :show="true"
      width="1000px"
      @close="closeDialog"
      @confirm="closeDialog"
    >
      <iframe
        v-if="iframeURL === null ? false : true"
        width="960"
        height="600"
        marginwidth="0"
        marginheight="0"
        frameborder="0"
        scrolling="no"
        :src="iframeURL"
      />
    </global-window>
    <add-account-drawer ref="addAccountDrawer" />

    <OfficialAccount
      v-if="bindAdvertisers.bool"
      :id="bindAdvertisers.id"
      :actives="bindAdvertisers.advertiser_id"
      :type="bindAdvertisers.advertiser_type"
      :identical="bindAdvertisers.isIdentical"
      @colse="(bindAdvertisers.bool = false),(bindAdvertisers.id = null)"
      @confirm="confirm"
    />
  </div>
</template>

<script>
import { getList, modify, getURL } from '@/api/report/accountManagement'
import UpdateWindow from './components/UpdateWindow.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import GlobalWindow from '@/components/GlobalWindow.vue'
import addAccountDrawer from '@/views/report/WeChatAccountFans/components/accountOfficialdrawer.vue'
import OfficialAccount from './components/officialAccount.vue'
export default {
  name: 'AccountManagement',
  components: {
    PaginationRight,
    UpdateWindow,
    GlobalWindow,
    addAccountDrawer,
    OfficialAccount
  },
  data() {
    return {
      tableData: {},
      flag: false,
      authorizeURL: null,
      wechatAccountsQuery: {
        wechat_account_name: null, // 公众号名称
        delivery_person: null, // 投手
        platform: null, // 平台
        novel_name: null, // 小说名
        lead: null, // 主角
        status: null, // 状态
        page: 1,
        page_size: 10
      },
      selectData: {}, // 列表数据，包括筛选条件数据
      loading: null, // 加载效果
      iframeURL: null,
      dialogVisible: false,
      bindAdvertisers: {
        // 控制绑定广告主的数据
        bool: false, // 控制绑定广告主
        wechat_id: null,
        advertiser_type: null, // 广告主类型
        advertiser_id: null, // 广告主账号
        advertisers: [], // 广告主
        isIdentical: null // 是否相同
      }
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (!newValue) {
        this.iframeURL = null
      }
    }
  },
  created() {
    this.getListData()
  },
  methods: {
    // 获取列表数据，包括筛选条件列表
    getListData() {
      this.loading = true
      getList(this.wechatAccountsQuery).then(res => {
        this.selectData = res.data
        this.loading = false
      })
    },
    // 跳转到授权页面
    getURLData() {
      this.dialogVisible = true
      getURL().then(res => {
        this.iframeURL = res.data.wechat
        // window.open(res.data)
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.iframeURL = null
    },
    // 搜索小说
    handleSearch() {
      this.wechatAccountsQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    handleReset() {
      this.wechatAccountsQuery = {
        wechat_account_name: null, // 公众号名称
        delivery_person: null, // 投手
        platform: null, // 平台
        novel_name: null, // 小说名
        lead: null, // 主角
        status: null, // 状态
        page: 1,
        page_size: 10
      }
      this.getListData()
    },
    // 分页
    fetchPageSize(e) {
      this.wechatAccountsQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.wechatAccountsQuery.page = e
      this.getListData()
    },
    // 发送辑数据请求
    getConfirmData(id, form) {
      modify(id, form).then(res => {
        this.getListData()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      })
    },

    // 绑定广告主
    getCommand(type, id, arr, types) {
      console.log('type', type, id, arr, types)

      // eslint-disable-next-line eqeqeq
      if (type == types) {
        this.bindAdvertisers.bool = true
        this.bindAdvertisers.id = id
        this.bindAdvertisers.advertiser_type = type
        this.bindAdvertisers.advertiser_id = []
        this.bindAdvertisers.isIdentical = true
      } else {
        this.bindAdvertisers.bool = true
        this.bindAdvertisers.id = id
        this.bindAdvertisers.advertiser_type = type
        this.bindAdvertisers.advertiser_id = []
        this.bindAdvertisers.isIdentical = false
      }
    },

    // 重置控制绑定广告主数据
    resetBindAdvertisers() {
      this.bindAdvertisers = {
        bool: false, // 控制绑定广告主
        id: null,
        advertiser_type: null, // 广告主类型
        advertiser_id: null, // 广告主账号
        advertisers: [] // 广告主
      }
    },

    confirm() {
      this.resetBindAdvertisers()
      this.getListData()
    },

    convertAdvertisers(advertiser_id) {
      if (!advertiser_id) {
        return null
      }
      const s = advertiser_id.map(item => `${item.account_id}(${item.account_name})`)
      let news = null
      if (s.length > 3) {
        news = s.slice(0, 3)
        news.push('...')
      }

      return news ? news.join('\n') : s.join('\n')
    }
  }
}
</script>

<style scoped lang="less">
.accountManagement {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
<style>
.aa {
  white-space: break-spaces;
}
</style>

